import {qspost} from '@/plugins/axios'

/*
 * 登录
 * */
export const login = (userName,userPass) => qspost('/organization/login/login', {userName,userPass})

/*
 * 手机短信快捷登陆
 * */
export const sms_login = (phone,code) => qspost('/api/Login/sms_login', {phone,code})

/*
 * 发送短信验证码
 * */
export const sendPhoneCode = (phone) => qspost('/api/Login/sendPhoneCode', {phone})

/*
 * 易魔方跳转登录
 * */
export const emof_login = (emofUserTokenSafer) => qspost('/organization/login/loginAutoByCookie', {emofUserTokenSafer})

/*
 * 版本列表
 * */
export const getVersionList = (page,limit) => qspost('/index/Iterative/getList', {page,limit})

/*
 * 版本详情：
 * */
export const getVersionDetail = (id) => qspost('/index/Iterative/getInfo', {id})

/*
 * 服务协议、隐私政策
 * */
export const getAgreement = () => qspost('/index/Common/miniAgreement', {})

